<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { chatActionStatusEnum, useChatStore } from '@/stores/chat.store'

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
})

const i18n = getI18n()
const chatStore = useChatStore()

const pending = computed(() => chatStore.pendingActions(props.message))
const includedCount = computed(() => pending.value.filter(action => !action.excluded).length)
const isDecided = computed(() => pending.value.some(action => action.decision !== undefined))
const isConfirming = computed(() => chatStore.isStreaming && pending.value.some(action => action.decision === chatActionStatusEnum.CONFIRMED))
const confirmLabel = computed(() => (pending.value.length > 1 ? i18n.t('chat.action.confirmSelected', { count: includedCount.value }) : i18n.t('common.confirm')))
</script>

<template>
  <q-card-actions align="right">
    <q-btn
      flat
      :label="i18n.t('common.cancel')"
      :disable="chatStore.isStreaming || isDecided"
      @click="chatStore.decideActionsAsync(message, false)"
    />
    <q-btn
      color="primary"
      icon="mdi-check"
      :label="confirmLabel"
      :loading="isConfirming"
      :disable="chatStore.isStreaming || isDecided || !message.id || !includedCount"
      @click="chatStore.decideActionsAsync(message, true)"
    />
  </q-card-actions>
</template>
